import ElementChangedEvent from 'core/utils/events/ElementChangedEvent';
import {
  EVENT_PRESSED,
  PressedChangedEvent,
  HTMLBnumToggleButton,
} from '../internal';

export function OnPressedChangeInitializer(
  event: PressedChangedEvent,
  instance: HTMLBnumToggleButton,
) {
  event.push((newValue, oldValue) => {
    instance.dispatchEvent(
      new ElementChangedEvent(EVENT_PRESSED, newValue, oldValue, instance),
    );
  });
}
